import React from "react";

const ReviewModal = ({ show, onClose, children }) => {
    return (
        <div
            className={`${
                !show && "hidden duration-300"
            } fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center z-[80] bg-black-30 h-full`}
        >
            <div
                onClick={onClose}
                className="absolute top-0 right-0 left-0 bottom-0 z-10"
            ></div>
            <div className="min-w-[300px] min-h-[100px] bg-white relative rounded-lg modal-fadeIn z-20 mx-2">
                <div className="w-full p-4 ">{children}</div>
            </div>
        </div>
    );
};

export default ReviewModal;
